/**
 * Canonical production origin (no trailing slash) — used for sitemap + structured data URLs.
 */
export const SITE_URL = 'https://www.albanosvilla.com';
